import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav'
import { PageEvent, MatSnackBar } from '@angular/material';
import * as Rx from 'rxjs/Rx';
import { SessionService } from '../../service/session/session.module';
import { LoadingService } from '../../directive/loading/loading.module';


@Component({
  selector: 'app-owner-expense-classification',
  templateUrl: './owner-expense-classification.component.html',
  styleUrls: ['./owner-expense-classification.component.css']
})
export class OwnerExpenseClassificationComponent implements OnInit {
  @ViewChild('drawer', { static: false }) drawerCtrl: MatDrawer;
  expenseClassificationList = [];
  expenseClassificationMin = {
    system: {
      company: {
        main: {
          uuid: ''
        }
      }
    },
    max: 10,
    offset: 0,
    filter: {
      name: '',
      value: ''
    }
  }
  paginatorModel = {
    total: 0,
    pageSizeOptions: [2, 5, 10, 25, 100, 200, 500, 1000],
  };
  // MatPaginator Output
  pageEvent: PageEvent;
  metadata = {
    searchBoxInput: new Rx.Subject<string>(),
    object: {
      main: {
        uuid: ''
      }
    }
  }
  constructor(private session: SessionService, public loadingService: LoadingService, public snackBar: MatSnackBar) { }

  ngOnInit() {
    this.getExpenseClassificationList();
  }
  /**Obtenemos la lista de clasificaciones de gasto***/
  getExpenseClassificationList() {
    this.loadingService.wait();
    this.expenseClassificationList = [];
    // verificamos en que pagina verificamos
    this.expenseClassificationMin.system.company.main.uuid = this.session.getSessionObject().main.uuid;
    this.session.getRequest("expenseClassification:list", this.expenseClassificationMin).subscribe(
      (data: any) => {
        this.expenseClassificationList = data.object.instanceList;
        this.paginatorModel.total = data.object.total;
        this.loadingService.hide();
      },
      error => {
        console.log("expenseClassification:list", error);
        this.loadingService.hide();
      }
    );
  }
  // funcion para obtener los datos del paginado.
  onPaginateChange(event) {
    this.expenseClassificationMin.offset = (event.pageIndex * event.pageSize);
    this.expenseClassificationMin.max = event.pageSize;
    this.getExpenseClassificationList();
  }

  handleUpdated(event) {
    this.expenseClassificationMin.offset = (this.pageEvent ? this.pageEvent.pageIndex * this.pageEvent.pageSize : this.expenseClassificationMin.offset);
    this.getExpenseClassificationList();
  }
  /* funcionalidad para cambiar el menú
  */
  toogleMenu(ev) {
    this.drawerCtrl.opened = ev;
  }

}
